import clone from "clone";

export class AdministratorSimple
{
	/**
	 * Creates a new instance of the type.
	 * @param data The response data from which the instance should be created.
	 */
	public constructor(data: any)
	{
		this.id = data.id;
		this.firstName = data.firstName;
		this.lastName = data.lastName;
		this.canBeDeactivated = data.canBeDeactivated;
	}

	public readonly id: number | undefined;

	public readonly firstName: string;

	public readonly lastName: string;
	
	public readonly canBeDeactivated: boolean;

	/**
	 * Gets a clone of this instance, suitable for editing.
	 */
	public clone(): any
	{
		return clone(this);
	}

	public get fullName(): string
	{
		return `${this.firstName} ${this.lastName}`;
	}

	public get initials(): string
	{
		return `${this.firstName[0]}${this.lastName[0]}`;
	}
}
